import { Ajax } from "@story/story_assets";

document.addEventSelectorListener("click", "a[href][data-remote='true']", function(event, target) {
	event.preventDefault();
	let href = target.getAttribute("href");

	Ajax.get(href);
	window.history.pushState({}, "", href);
});